import { render, staticRenderFns } from "./ScsSeqConfigList.vue?vue&type=template&id=72e2c532&scoped=true&"
import script from "./ScsSeqConfigList.vue?vue&type=script&lang=js&"
export * from "./ScsSeqConfigList.vue?vue&type=script&lang=js&"
import style0 from "./ScsSeqConfigList.vue?vue&type=style&index=0&id=72e2c532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e2c532",
  null
  
)

export default component.exports